import axios from 'axios';
import {
    Message,
    MessageBox,
    Loading
} from 'element-ui';
import consts from '@/consts/index.js';
let env = process.env.NODE_ENV;
console.log('show this env------', env);
import { getCookie } from '@/utils';

axios.defaults.withCredentials = false
    /**
     * Create Axios
     */
export const http = axios.create({
    // baseURL: env === 'production' ? 'http://content.msa.chinamcloud.cn' : '',
    // baseURL: window.CONFIG.API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    transformResponse: [
        data => {
            try {
                data = data ? JSON.parse(data) : '';
                // if (data && data.code && (data.code !== 10000)) {
                //     Message({
                //         message: data.description || data.returnDesc || data.message,
                //         type: 'error',
                //         duration: consts.ELEMENT_UI_MSG_DURATION
                //     });
                // }
            } catch (error) {
                console.error('JSON.parse转换错误', error);
            }
            return data;
        }
    ],
});

http.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept-Content-Type': 'application/json',
    'Accept-Language': getCookie('locale') || 'zh_cn'
};

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */


// LOADING 实例
window.loadingInstance = null;
// request拦截
http.interceptors.request.use(
    config => {
        if (loadingInstance) {
            loadingInstance.close();
        }

        // 加载中样式
        if (config.hasOwnProperty('loading') && config.loading) {
            let options = {
                fullscreen: true,
                spinner: 'el-icon-loading',
                background: '#FFF'
            };
            if (config.hasOwnProperty('method')) {
                if (config.method.toLowerCase() === 'get') {
                    options.text = '数据加载中';
                } else {
                    options.text = '加载中';
                    options.lock = true;
                    options.background = 'rgba(0, 0, 0, 0.7)';
                }
            }
            if (typeof config === 'object') {
                options = _.assign(options, config.loading);
            }
            window.loadingInstance = Loading.service(options);
        }

        return config;
    },
    error => {
        Promise.reject(error);
    }
);

/**
 * Handle all error messages.
 */
http.interceptors.response.use(
    function(response) {
        if (loadingInstance !== null) {
            window.loadingInstance.close();
        }
        return response.data;
    },
    function(error) {
        const {
            response
        } = error;

        if (loadingInstance !== null) {
            window.loadingInstance.close();
        }
        if ([401].indexOf(response.status) >= 0) {
            if (
                response.status == 401 &&
                response.data.message != 'Unauthenticated.'
            ) {
                return Promise.reject(response);
            }
            return;
        }

        if ([403].indexOf(response.status) >= 0) {
            Message({
                message: response.data.message,
                type: 'error',
                duration: consts.ELEMENT_UI_MSG_DURATION
            });

        }
        // console.log(response, error, '答应拦截信息')
        // Message({
        //   message: error.message,
        //   type: 'error',
        //   duration: consts.ELEMENT_UI_MSG_DURATION
        // });
        return Promise.reject(response.data);
    }
);

export default function install(Vue) {
    Object.defineProperty(Vue.prototype, '$requests', {
        get() {
            return http;
        }
    });
}


// WEBPACK FOOTER //
// ./src/plugins/http/index.js